export enum ContentViewMode {
    List = "list",
    Thumbs = "thumbs",
}

export type EquipmentParamType = Partial<{
    modelId: string;
    carId: string;
    carColourId?: string;
    contentViewMode?: ContentViewMode; // Change the viewMode of the displayed content
}>;
